module.exports = __webpack_public_path__ + "img/template-email-gallery.8935fc80.svg";